import React from 'react';
import PropTypes from 'prop-types';

const GlobeLang = ({ color }) => (
  <svg height="100%" width="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.6 18.26h-1.545a1 1 0 00-.767.358l-.075.103-.713 1.111-.713-1.111-.075-.103a1 1 0 00-.767-.358H14.4V14.4h6.2v3.86zm-8 .4a1.4 1.4 0 001.4 1.4h1.508l1.15 1.795a1 1 0 001.684 0l1.15-1.794H21a1.4 1.4 0 001.4-1.4V14a1.4 1.4 0 00-1.4-1.4h-7a1.4 1.4 0 00-1.4 1.4v4.66zM12.393 1.957a.9.9 0 011.206.018l.065.065.369.442c1.672 2.093 2.636 4.657 3.075 7.324l.086.572.008.092a.9.9 0 01-1.775.242l-.017-.09-.08-.526c-.401-2.44-1.268-4.694-2.703-6.49l-.317-.378-.056-.072a.9.9 0 01.14-1.199zM11.541 1.905a.9.9 0 00-1.199.128l-.058.073-.341.485C6.52 7.603 6.537 12.38 7.457 15.926a18.078 18.078 0 001.767 4.345c.294.518.56.926.756 1.208.097.14.178.25.235.326l.088.114.006.008.002.003c.001.001.01-.005.562-.451l-.56.452a.9.9 0 101.4-1.13h.001V20.8l-.012-.014-.048-.063a8.804 8.804 0 01-.196-.27 14.141 14.141 0 01-.669-1.07 16.286 16.286 0 01-1.589-3.91c-.813-3.137-.85-7.36 2.233-11.873l.308-.438.05-.077a.9.9 0 00-.25-1.18z"
      fill={color}
    />
    <path
      d="M1.644 12.025C1.644 6.268 6.312 1.6 12.07 1.6c4.383 0 9.143 3.146 10.165 8.738a.9.9 0 01-1.77.324C19.61 5.992 15.653 3.4 12.07 3.4a8.625 8.625 0 00-1.107 17.18h.104a.9.9 0 01.348 1.729c-.005.002-.01.007-.015.01a.907.907 0 01-.331.08l-.038.001h-.026a.896.896 0 01-.083-.005l-.044-.003-.05-.006a1.265 1.265 0 01-.121-.026c-5.114-.668-9.063-5.039-9.063-10.335z"
      fill={color}
    />
    <path
      d="M20.634 7.67l.091.005a.9.9 0 010 1.79l-.091.006H3.367a.9.9 0 010-1.801h17.267zM10.5 14.53l.092.004a.9.9 0 010 1.791l-.092.005H3.367a.9.9 0 010-1.8H10.5z"
      fill={color}
    />
  </svg>
);

GlobeLang.propTypes = {
  color: PropTypes.string.isRequired,
};

export default GlobeLang;
